import React, {useEffect, useState} from 'react';
//import axios from 'axios';
import Loader from '../../loader';
import { API_BASE_URL } from '../../../constants';
import addProductCSS from '../addProduct/addProduct.module.css';
import CustomAlert from '../../customAlert';
import { axiosAuthFetch, axiosImageAuthFetch } from '../../../helpers/apiActions/authFetch';

export function AddVerkstedForm() {
    const [isLoading, setIsLoading] = useState(false);
    const [username, setUsername] = useState('');
    const [kjeder, setKjeder] = useState([]);
    const [selectedKjedeId, setSelectedKjedeId] = useState('');
    const [file, setFile] = useState(null);
    const [email, setEmail] = useState('');
    const [region, setRegion] = useState('');
    const [country, setCountry] = useState('');
    const [city, setCity] = useState('');
    const [street, setStreet] = useState('');
    const [zip, setZip] = useState('');
    const [contactName, setContactName] = useState('');
    const [contactEmail, setContactEmail] = useState('');
    const [contactPhone, setContactPhone] = useState('');

    
    useEffect(()=> {
        setIsLoading(true);
        async function fetchKjeder() {
            try{
                const kjedeResponse = await axiosAuthFetch(`${API_BASE_URL}/kjedes`)
                // console.log(kjedeResponse.data.data);
                setKjeder(kjedeResponse.data);
            } catch(error) {
                console.error(error);
            }finally {
                setIsLoading(false);
            }
        }
        fetchKjeder();
    }, [])

    const handleUsernameChange = (event) => {
        setUsername(event.target.value);
    }

    const handleKjedeChange = (event) => {
        setSelectedKjedeId(event.target.value);
    }

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    }

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    }

    const handleRegionChange = (event) => {
        setRegion(event.target.value);
    };
    const handleCountryChange = (event) => {
        setCountry(event.target.value);
    };
    const handleStreetChange = (event) => {
        setStreet(event.target.value);
    };
    const handleZipChange = (event) => {
        setZip(event.target.value);
    };
    const handleCityChange = (event) => {
        setCity(event.target.value);
    };
    const handleContactNameChange = (event) => {
        setContactName(event.target.value);
    };
    const handleContactEmailChange = (event) => {
        setContactEmail(event.target.value);
    };
    const handleContactPhoneChange = (event) => {
        setContactPhone(event.target.value);
    };

   const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        try {
            

            const verkstedData = new FormData();
            verkstedData.append('role', 3);
            verkstedData.append('confirmed', 'true');
            verkstedData.append('username', username);
            verkstedData.append('password', '1234abcd');
            verkstedData.append('email', email);
            verkstedData.append('kjede', selectedKjedeId);
            //verkstedData.append('address', address)

            //console.log(verkstedData);


            const verkstedResponse = await axiosImageAuthFetch('https://renowned-oasis-58a898da10.strapiapp.com/api/users', verkstedData, 'post');
            const verkstedID = verkstedResponse.id;

             const address = {
                 address: {
                "street" : street,
                "zip" : zip,
                "country" : country,
                "region" : region,
                "city" : city
                }
            }  

            const contactInfo = {
                contact_person: {
                    "name" : contactName,
                    "email" : contactEmail,
                    "telephone" : contactPhone
                }
            }

            //const updateInfo = 
            // const addressData = new FormData();
            // addressData.append('address', address)
            // addressData.append('contact_info', contactInfo)
            // address.append('street', street);
            // address.append('zip', zip);
            // address.append('country', country);
            // address.append('region', region);
            // address.append('city', city);

            //console.log(address);

            const addressResponse = await axiosAuthFetch(`${API_BASE_URL}/users/${verkstedID}`, address, 'put')
            const contactResponse = await axiosAuthFetch(`${API_BASE_URL}/users/${verkstedID}`, contactInfo, 'put')
            console.log(addressResponse, contactResponse);

            const imageData = new FormData();
            imageData.append('ref', 'plugin::users-permissions.user');
            imageData.append('refId', verkstedID);
            imageData.append('field', 'image');
            imageData.append('files', file);

            const imageResponse = await axiosImageAuthFetch('https://renowned-oasis-58a898da10.strapiapp.com/api/upload', imageData, 'post');
            console.log(imageResponse);
           
                <CustomAlert 
                    message="Verksted opprettet!"
                />
                window.location.href="/VP/admin/verksteder"
        } catch(error) {
            console.error(error);
        }finally {
            setIsLoading(false);
        }
    }
    return(
        <div>
            {isLoading && <Loader />}
            <form className={addProductCSS.form} onSubmit={handleSubmit}>
                <div>Verkstedinfo</div>
                <input className={addProductCSS.input} type="text" value={username} onChange={handleUsernameChange} placeholder="Navn på verksted" required/>
                <input className={addProductCSS.input} type="text" value={email} onChange={handleEmailChange} placeholder="E-post" required/>
                <div>Adresseinfo</div>
                <input className={addProductCSS.input} type="text" value={city} onChange={handleCityChange} placeholder="By" />
                <input className={addProductCSS.input} type="text" value={street} onChange={handleStreetChange} placeholder="Adresse" />
                <input className={addProductCSS.input} type="text" value={zip} onChange={handleZipChange} placeholder="Postkode" />
                <input className={addProductCSS.input} type="text" value={region} onChange={handleRegionChange} placeholder="Region" />
                <input className={addProductCSS.input} type="text" value={country} onChange={handleCountryChange} placeholder="Land" />
                <div>Kontakt-person</div>
                <input className={addProductCSS.input} type="text" value={contactName} onChange={handleContactNameChange} placeholder="Navn" />
                <input className={addProductCSS.input} type="text" value={contactEmail} onChange={handleContactEmailChange} placeholder="E-mail" />
                <input className={addProductCSS.input} type="text" value={contactPhone} onChange={handleContactPhoneChange} placeholder="Telefonnummer" />
                {/* <select className={addProductCSS.select} value={selectedSupplierId} onChange={handleSupplierChange} required>
                    <option value="">Velg leverandør</option>
                        {suppliers.map(supplier => (
                            <option key={supplier.id} value={supplier.id}>{supplier.attributes.name}</option>
                        ))}
                </select> */}
                <div>Kjede</div>
                <select className={addProductCSS.select} value={selectedKjedeId} onChange={handleKjedeChange} required>
                    <option value="">Velg kjede</option>
                        {kjeder.map(kjede => (
                            <option key={kjede.id} value={kjede.id}>{kjede.attributes.name}</option>
                        ))}
                </select>
                <h3 className={addProductCSS.h3}>Bilde</h3>
                <input className={addProductCSS.fileInput}  type="file" onChange={handleFileChange} />
                <button className={addProductCSS.button} type="submit">Opprett verksted</button>
            </form>
        </div>
    )
}

export default AddVerkstedForm;